const ENV =
  typeof window !== 'undefined' && window.ENV
    ? window.ENV
    : {
        BAZAAR_API_BASE_URL: process.env.REACT_APP_BAZAAR_API_BASE_URL,
        DASHBOARD_CLIENT_V2_BASE_URL:
          process.env.REACT_APP_DASHBOARD_CLIENT_V2_BASE_URL,
        PUBLISH_URL: process.env.REACT_APP_PUBLISH_URL,
        RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID,
        RAZORPAY_MERCHANT_ID: process.env.REACT_APP_RAZORPAY_MERCHANT_ID,
        AUTH_PROVIDER: process.env.REACT_APP_AUTH_PROVIDER,
        COGNITO_REGION: process.env.REACT_APP_COGNITO_REGION,
        COGNITO_USER_POOL_CLIENT_ID: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
        MOBILE_APP_ANDROID_URL: process.env.REACT_APP_MOBILE_APP_ANDROID_URL,
        MOBILE_APP_IOS_URL: process.env.REACT_APP_MOBILE_APP_IOS_URL,
      };

const DEFAULT_MOBILE_APP_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.app.rapchik&hl=en';
const DEFAULT_MOBILE_APP_IOS_URL = 'https://apps.apple.com/in/app/rapchik/id6753069743';

export const BASE_URL_BAZAAR = `${ENV.BAZAAR_API_BASE_URL || ''}`;
export const BASE_URL_CLIENT_V2 = `${ENV.DASHBOARD_CLIENT_V2_BASE_URL || ''}`;
export const PUBLISH_URL = `${ENV.PUBLISH_URL || ''}`;
export const RAZORPAY_KEY_ID = `${ENV.RAZORPAY_KEY_ID || ''}`;
export const RAZORPAY_MERCHANT_ID = `${ENV.RAZORPAY_MERCHANT_ID || ''}`;
export const AUTH_PROVIDER = `${ENV.AUTH_PROVIDER || ''}`.toLowerCase();
export const COGNITO_REGION = `${ENV.COGNITO_REGION || process.env.REACT_APP_COGNITO_REGION || 'ap-south-1'}`;
export const COGNITO_USER_POOL_CLIENT_ID = `${ENV.COGNITO_USER_POOL_CLIENT_ID || process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || ''}`;
export const MOBILE_APP_ANDROID_URL = `${
  ENV.MOBILE_APP_ANDROID_URL ||
  process.env.REACT_APP_MOBILE_APP_ANDROID_URL ||
  DEFAULT_MOBILE_APP_ANDROID_URL
}`;
export const MOBILE_APP_IOS_URL = `${
  ENV.MOBILE_APP_IOS_URL || process.env.REACT_APP_MOBILE_APP_IOS_URL || DEFAULT_MOBILE_APP_IOS_URL
}`;

const ROUTES = {
  CLIENT_V2: 'api/client/v1',
};

export { ROUTES };
